import React from 'react';
import ChatItem from './chatItem';

interface ChatListProps {
  chats?: Array<IUserChatsResults>;
  optionsChatItem: Array<TOption>;
}
const ChatList = ({optionsChatItem, chats}: ChatListProps) => {
  return (
    <div className="grid grid-cols-1 divide-y w-full bg-white  overflow-y-auto 	px-4">
      <div className=" divide-y" />
      {chats?.map((item, index) => {
        return (
          <div key={index}>
            <ChatItem
              id={item.guid}
              optionsChatItem={optionsChatItem}
              created_at={item.created_at}
              name={item.contact_detail.name}
              is_seen={item.is_seen}
              last_message_text={item.last_message_text}
            />
          </div>
        );
      })}
      <div className=" divide-y" />
    </div>
  );
};

export default ChatList;
